/*eslint-disable import/default */
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { addLocaleData } from 'react-intl';
import { Provider } from 'react-redux';

import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName } from '@material-ui/styles';

import registerServiceWorker from './registerServiceWorker';
import ConnectedIntlProvider from './intl/ConnectedIntlProvider';

// eslint-disable-next-line
import colors from './styles/colors.css';
// eslint-disable-next-line
import fonts from './styles/fonts.css';
// eslint-disable-next-line
import common from './styles/common.css';

import { } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';

import configureStore from './store/configure.store';

import App from './pages/app';

require('dotenv').config();

addLocaleData([...en, ...es]);

const store = configureStore();

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
//injectTapEventPlugin();

registerServiceWorker();

const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'c',
});

export default App;

ReactDOM.render(
    <Provider store={store}>
        <ConnectedIntlProvider>
            <JssProvider generateClassName={generateClassName}>
                <App />
            </JssProvider>
        </ConnectedIntlProvider>
    </Provider>,
    document.querySelector('#root'),
);



// WEBPACK FOOTER //
// ./src/index.js